import React, { forwardRef } from 'react';

import { CellSelectionProvider } from './CellSelectionProvider';
import EPGComponent from './EPGComponent';
import { EPGProps, IEPG } from './types';

const EPG = forwardRef<IEPG, EPGProps<any, any>>((props, ref) => (
    <CellSelectionProvider>
        <EPGComponent ref={ref} {...props} />
    </CellSelectionProvider>
));

export default EPG;
